// One browser lifecycle subscription for all quote consumers. Timers can pause
// during device sleep; compare wall time as well as listening for tab returns.
const listeners = new Set()
let stop = null

export function subscribeBrowserResume(listener) {
  if (typeof window === 'undefined' || typeof document === 'undefined') return () => {}
  listeners.add(listener)
  if (listeners.size === 1) {
    let lastCheck = Date.now()
    const notify = () => {
      lastCheck = Date.now()
      for (const callback of listeners) {
        try { callback() } catch { /* isolate sibling consumers */ }
      }
    }
    const visible = () => {
      if (document.visibilityState !== 'hidden') notify()
    }
    const windowEvents = ['focus', 'pageshow', 'online']
    for (const event of windowEvents) window.addEventListener(event, notify)
    document.addEventListener('visibilitychange', visible)
    document.addEventListener('resume', notify)
    const timer = setInterval(() => {
      const now = Date.now()
      if (now - lastCheck > 60_000 || now < lastCheck) notify()
      lastCheck = now
    }, 30_000)
    stop = () => {
      clearInterval(timer)
      for (const event of windowEvents) window.removeEventListener(event, notify)
      document.removeEventListener('visibilitychange', visible)
      document.removeEventListener('resume', notify)
    }
  }
  return () => {
    listeners.delete(listener)
    if (listeners.size === 0) {
      stop?.()
      stop = null
    }
  }
}
